export default {
    items: [
        {
            name: 'Administracion',
            title: true,
        },
        {
            name: 'Servicios Maestros',
            icon: 'fas fa-globe-americas',
            children: [
                {
                    name: 'Lista',
                    icon: 'fas fa-bars',
                    url: '/master_services',
                    permission: 'masterservices',
                },
            ],
        },
        {
            name: 'Servicios',
            icon: 'fas fa-globe-americas',
            children: [
                {
                    name: 'Lista',
                    icon: 'fas fa-bars',
                    url: '/services_new',
                    permission: 'services',
                },
                {
                    name: 'Clasificaciones',
                    icon: 'fas fa-boxes',
                    url: '/classifications',
                    permission: 'classifications',
                },
                {
                    name: 'Incluyentes',
                    icon: 'fas fa-tasks',
                    url: '/inclusions',
                    permission: 'inclusions',
                },
                {
                    name: 'Experiencias',
                    icon: 'fas fa-hiking',
                    url: '/experiences',
                    permission: 'experiences',
                },
                {
                    name: 'Requisitos',
                    icon: 'fas fa-check-double',
                    url: '/requirements',
                    permission: 'requirements',
                },
                {
                    name: 'Restricciones',
                    icon: 'fas fa-ban',
                    url: '/restrictions',
                    permission: 'restrictions',
                },
                {
                    name: 'Tipo de Operatividad',
                    icon: 'fas fa-list-alt',
                    url: '/type_operability',
                    permission: 'servicetypeactivities',
                },
                {
                    name: 'Tipo de Servicios',
                    icon: 'fas fa-th-list',
                    url: '/type_service',
                    permission: 'servicecategories',
                },
                {
                    name: 'Categorías',
                    icon: 'fas fa-th-list',
                    url: '/service_category',
                    permission: 'servicetypes',
                },
                {
                    name: 'Politicas de cancelación',
                    icon: 'fas fa-business-time',
                    url: '/cancellation_policies',
                    permission: 'cancellationpolicies',
                },
                {
                    name: 'Tags',
                    icon: 'fas fa-th-list',
                    url: '/tagservices',
                    permission: 'tagservices',
                },
                {
                    name: 'Destacados',
                    icon: 'fas fa-check-double',
                    url: '/featured_service',
                    permission: 'informationimportantservices',
                },
                {
                    name: 'Instrucciones',
                    icon: 'fas fa-check-double',
                    url: '/instructions',
                    permission: 'instructions',
                },
                {
                    name: 'Orden Tarifario',
                    icon: 'fas fa-check-double',
                    url: '/order_rates',
                    permission: 'orderratesservices',
                },
                {
                    name: 'Configuración Markups',
                    icon: 'fas fa-cogs',
                    url: '/services_markups',
                    permission: 'markupsconfigurationservices',
                },
            ],
        },
        {
            name: 'Paquetes',
            icon: 'fas fa-globe-americas',
            children: [
                {
                    name: 'Lista',
                    icon: 'fas fa-bars',
                    url: '/packages',
                    permission: 'packages',
                },
                {
                    name: 'Intereses',
                    icon: 'fas fa-bars',
                    url: '/packages/groups',
                    permission: 'packages',
                },
                {
                    name: 'Exportar Tarifas',
                    icon: 'fas fa-file-excel',
                    url: '/packages/export',
                    permission: 'packages',
                },
                {
                    name: 'Permisos',
                    icon: 'fas fa-unlock-alt',
                    url: '/packages/permissions',
                    permission: 'packagepermissions',
                },
                {
                    name: 'Highlights',
                    icon: 'fas fa-images',
                    url: '/packages/highlights',
                    permission: 'highlights',
                },
                {
                    name: 'Políticas de cancelación',
                    icon: 'fas fa-business-time',
                    url: '/packages/cancellation_policies',
                    permission: 'packagecancellationpolicies',
                },
            ],
        },
        {
            name: 'Hoteles',
            icon: 'fas fa-hotel',
            children: [
                {
                    name: 'Lista',
                    icon: 'fas fa-bars',
                    url: '/hotels',
                    permission: 'hotels',
                },
                {
                    name: 'Cadenas',
                    icon: 'fas fa-link',
                    url: '/chains',
                    permission: 'chains',
                },
                {
                    name: 'Amenidades',
                    icon: 'fas fa-futbol',
                    url: '/amenities',
                    permission: 'amenities',
                },
                {
                    name: 'Meals',
                    icon: 'fas fa-drumstick-bite',
                    url: '/meals',
                    permission: 'meals',
                },
                {
                    name: 'Tipos de Hotel',
                    icon: 'fas fa-donate',
                    url: '/hotel_types',
                    permission: 'hoteltypes',
                },
                {
                    name: 'Tipos de Habitación',
                    icon: 'fas fa-bed',
                    url: '/room_types',
                    permission: 'roomtypes',
                },
                {
                    name: 'Categoria Hotel',
                    icon: 'fas fa-share-alt',
                    url: '/hotelcategories',
                    permission: 'hotelcategories',
                },
                {
                    name: 'Channel',
                    icon: 'fas fa-list-alt',
                    url: '/channels',
                    permission: 'channels',
                },
                {
                    name: 'Suplementos',
                    icon: 'fas fa-list-alt',
                    url: '/suplements',
                    permission: 'supplements',
                },
                {
                    name: 'Orden Tarifario',
                    icon: 'fas fa-check-double',
                    url: '/hotel_order_rates',
                    permission: 'orderrateshotels',
                },
                {
                    name: 'Configuración Markups',
                    icon: 'fas fa-cogs',
                    url: '/hotels_markups',
                    permission: 'orderrateshotels',
                },
                {
                    name: 'Suscripcion Hyperguest',
                    icon: 'fas fa-cogs',
                    url: '/hotels_suscription_hyperguest',
                    permission: 'supplements',
                },
                {
                    name: 'Reporte Hyperguest',
                    icon: 'nav-icon fas fa-share-alt',
                    url: '/report-hyperguest',
                    permission: 'supplements',
                },
            ],
        },
        {
            name: 'Trenes',
            icon: 'fas fa-train',
            children: [
                {
                    name: 'Lista',
                    icon: 'fas fa-bars',
                    url: '/trains',
                    permission: 'trains',
                },
                {
                    name: 'Rutas',
                    icon: 'fas fa-subway',
                    url: '/train_routes',
                    permission: 'trains',
                },
                {
                    name: 'Clases',
                    icon: 'fas fa-external-link-alt',
                    url: '/train_classes',
                    permission: 'trains',
                },
                {
                    name: 'Usuarios',
                    icon: 'fas fa-user',
                    url: '/train_users',
                    permission: 'trains',
                },
                {
                    name: 'Politicas de cancelación',
                    icon: 'fas fa-business-time',
                    url: '/train_cancellations',
                    permission: 'trains',
                },
            ],
        },
        {
            name: 'Clientes',
            icon: 'fas fa-globe',
            url: '/clients',
            permission: 'clients',
        },
        {
            name: 'Reportes',
            icon: 'fas fa-file-alt',
            url: '/reports',
            permission: 'reports',
        },
        {
            name: 'Fotos',
            icon: 'fas fa-images',
            children: [
                {
                    name: 'Lista',
                    icon: 'fas fa-bars',
                    url: '/photos',
                    permission: 'photos',
                },
            ],
        },
        {
            name: 'Tickets',
            icon: 'fas fa-ticket-alt',
            url: '/tickets',
            permission: 'tickets',
        },
        {
            name: 'Auditoria',
            icon: 'fas fa-file-signature',
            children: [
                {
                    name: 'Paquetes',
                    icon: 'fas fa-folder',
                    url: '/audit/package',
                    permission: 'auditpackages',
                },
                {
                    name: 'Clientes',
                    icon: 'fas fa-folder',
                    url: '/audit/client',
                    permission: 'auditclients',
                },
                {
                    name: 'Servicios',
                    icon: 'fas fa-folder',
                    url: '/audit/service',
                    permission: 'auditservices',
                },
            ],
        },
        {
            name: 'Negociaciones',
            title: true,
        },
        {
            name: 'Producto',
            icon: 'fas fa-list-alt',
            url: '/a3/negotiations/products/general',
            permission: 'products',
        },
        {
            name: 'Producto específico',
            icon: 'fas fa-list-alt',
            url: '/a3/negotiations/products/management',
            permission: 'specificproducts',
        },
        {
            name: 'Proveedores',
            icon: 'fas fa-user',
            children: [
                {
                    name: 'Transporte',
                    icon: 'fas fa-bus',
                    url: '/a3/negotiations/suppliers/transports',
                    permission: 'suppliertransport',
                },
                {
                    name: 'Atractivos turísticos',
                    icon: 'fas fa-landmark',
                    url: '/a3/negotiations/suppliers/tourist-attractions',
                    permission: 'suppliertouristattraction',
                },
                {
                    name: 'Restaurante',
                    icon: 'fas fa-utensils',
                    url: '/a3/negotiations/suppliers/restaurants',
                    permission: 'supplierrestaurant',
                },
                {
                    name: 'Operador turístico',
                    icon: 'fas fa-user',
                    url: '/a3/negotiations/suppliers/tour-operators',
                    permission: 'suppliertouroperator',
                },
                {
                    name: 'Staff',
                    icon: 'fas fa-users',
                    url: '/a3/negotiations/suppliers/staff',
                    permission: 'supplierstaff',
                },
                {
                    name: 'Misceláneos',
                    icon: 'fas fa-cubes',
                    url: '/a3/negotiations/suppliers/miscellaneous',
                    permission: 'suppliermiscellaneous',
                }
            ],
        },
        {
            name: 'Protecciones',
            icon: 'fas fa-book',
            url: '/a3/negotiations/protections',
            permission: 'protections',
        },
        {
            name: 'Operaciones',
            title: true,
        },
        {
            name: 'Calendario de bloqueo',
            icon: 'fas fa-calendar',
            url: '/a3/ope/lockdown-calendar',
            permission: 'lockdowncalendar',
        },
        {
            name: 'Pautas Operativas',
            icon: 'fas fa-cog',
            url: '/a3/ope/guidelines',
            permission: 'operationalguidelines',
        },
        {
            name: 'Programación de servicios',
            icon: 'fas fa-list-alt',
            url: '/a3/ope/service-management',
            permission: 'servicescheduling',
        },
        {
            name: 'Servicios programados',
            icon: 'fas fa-user',
            url: '/a3/ope/providers',
            permission: 'scheduledservices',
        },
        {
            name: 'Torre de control',
            icon: 'fas fa-hotel',
            url: '/a3/ope/tower',
            permission: 'controltower',
        },
        {
            name: 'Gestión de Rendiciones',
            icon: 'fas fa-tags',
            url: '/a3/ope/management-reports',
            permission: 'opemanagementreports',
        },
        {
            name: 'Gestión',
            title: true,
        },
        {
            name: 'Ubigeo',
            icon: 'fas fa-globe-americas',
            children: [
                {
                    name: 'Paises',
                    icon: 'fas fa-globe-americas',
                    url: '/countries',
                    permission: 'countries',
                },
                {
                    name: 'Estados',
                    icon: 'fas fa-globe-americas',
                    url: '/states',
                    permission: 'states',
                },
                {
                    name: 'Ciudades',
                    icon: 'fas fa-globe-americas',
                    url: '/cities',
                    permission: 'cities',
                },
                {
                    name: 'Distritos',
                    icon: 'fas fa-globe-americas',
                    url: '/districts',
                    permission: 'districts',
                },
                {
                    name: 'Zonas',
                    icon: 'fas fa-vector-square',
                    url: '/zones',
                    permission: 'zones',
                },
            ],
        },
        {
            name: 'Regiones',
            icon: 'fas fa-globe-americas',
            url: '/business_region',
            permission: 'businessregion',
        },
        {
            name: 'Roles',
            icon: 'fas fa-user-tie',
            url: '/roles',
            permission: 'roles',
        },
        {
            name: 'Permisos',
            icon: 'fas fa-user-lock',
            url: '/permissions',
            permission: 'permissions',
        },
        {
            name: 'Usuarios',
            icon: 'fas fa-user',
            url: '/users',
            permission: 'users',
        },
        {
            name: 'Areas',
            icon: 'fas fa-sitemap',
            url: '/departments',
            permission: 'departments',
        },
        {
            name: 'Cargos',
            icon: 'fas fa-user-graduate',
            url: '/positions',
            permission: 'positions',
        },
        {
            name: 'Proveedores',
            icon: 'fas fa-user',
            url: '/suppliers',
            permission: 'suppliers',
        },
        {
            name: 'Reservas',
            icon: 'fas fa-cogs',
            children: [
                {
                    name: 'Lista',
                    icon: 'fas fa-clipboard-list',
                    url: '/bookings',
                    permission: 'bookings',
                },
            ],
        },
        {
            name: 'Masi',
            icon: 'fas fa-robot',
            children: [
                {
                    name: 'Encuesta',
                    icon: 'fas fa-poll-h',
                    url: '/masi',
                    permission: 'masi',
                },
                {
                    name: 'Configuración',
                    icon: 'fas fa-cog',
                    url: '/masi_mailing',
                    permission: 'masimailing',
                },
                {
                    name: 'Configuración - ChatBot',
                    icon: 'fas fa-cog',
                    url: '/masi_url',
                    permission: 'mfconfigurationmasi',
                },
            ],
        },
        {
            name: 'Auxiliares',
            title: true,
        },
        {
            name: 'Idiomas',
            icon: 'fas fa-globe',
            url: '/languages',
            permission: 'languages',
        },
        {
            name: 'Traducciones',
            icon: 'fas fa-globe',
            url: '/translations',
            permission: 'translations',
        },
        {
            name: 'Monedas',
            icon: 'fas fa-money-bill',
            url: '/currencies',
            permission: 'currencies',
        },
        {
            name: 'Unidad de medida',
            icon: 'fas fa-balance-scale',
            url: '/units',
            permission: 'units',
        },
        {
            name: 'Unidad de duración',
            icon: 'far fa-hourglass',
            url: '/unitdurations',
            permission: 'unitdurations',
        },
        {
            name: 'Mercados',
            icon: 'fas fa-industry',
            url: '/markets',
            permission: 'markets',
        },
        {
            name: 'Clases',
            icon: 'fas fa-external-link-alt',
            url: '/typesclass',
            permission: 'typesclass',
        },
        {
            name: 'Clases Virtuales',
            icon: 'fas fa-external-link-alt',
            url: '/virtualclass',
            permission: 'virtualclass',
        },
        {
            name: 'Intensidad fisica',
            icon: 'fas fa-heartbeat',
            url: '/physical_intensities',
            permission: 'physicalintensities',
        },
        {
            name: "Sedes",
            icon: "fas fa-building",
            url: "/branches",
            permission: "branches",
        },
        {
            name: 'Seg. de Gestión',
            icon: 'fas fa-list-alt',
            url: '/a3/accountancy/sig-tracking-platform/management-monitoring',
            permission: 'managementmonitoring',
        },
        {
            name: 'Coment. de Mejora',
            icon: 'fas fa-globe',
            url: '/a3/accountancy/sig-tracking-platform/suggestions-for-improvement',
            permission: 'suggestionsforimprovement',
        },
        {
            name: 'Mant. de Sanciones',
            icon: 'fas fa-cogs',
            url: '/a3/accountancy/sig-tracking-platform/maintenance-of-sanctions',
            permission: 'maintenanceofsanctions',
        },
        {
            name: 'CUSTOMER SERVICE',
            title: true,
        },
        {
            name: 'Reclamos',
            icon: 'fas fa-folder',
            url: '/a3/accountancy/customer-service/claims',
            permission: 'claims',
        },
        {
            name: 'Reporte en Operación',
            icon: 'fas fa-folder',
            url: '/a3/accountancy/customer-service/reports',
            permission: 'reports',
        },
        {
            name: 'ADVENTURE',
            title: true,
        },
        {
            name: 'Categorías',
            icon: 'fas fa-tags',
            url: '/a3/adventure/categories',
            permission: 'acategories',
        },
        {
            name: 'Configuración',
            icon: 'fas fa-cog',
            url: '/a3/adventure/configuration',
            permission: 'asettings',
        },
        {
            name: 'Plantillas',
            icon: 'fas fa-copy',
            url: '/a3/adventure/templates',
            permission: 'templates',
        },
        {
            name: 'Salidas',
            icon: 'fas fa-calendar',
            url: '/a3/adventure/departures',
            permission: 'departures',
        },
        {
            name: 'Entradas',
            icon: 'fas fa-ticket-alt',
            url: '/a3/adventure/entrances',
            permission: 'entrances',
        },
        {
            name: 'Efectivo',
            icon: 'fas fa-money-bill',
            url: '/a3/adventure/cash',
            permission: 'cash',
        },
        {
            name: 'Programación',
            icon: 'fas fa-list',
            url: '/a3/adventure/programming',
            permission: 'programming',
        },
        {
            name: 'Manifiesto Paxs',
            icon: 'fas fa-user-tie',
            url: '/a3/adventure/manifest',
            permission: 'manifest',
        },
        {
            name: 'Calendario',
            icon: 'fas fa-calendar-alt',
            url: '/a3/adventure/calendar',
            permission: 'acalendar',
        },
        {
            name: 'Servicios Extra',
            icon: 'fas fa-plus',
            url: '/a3/adventure/services',
            permission: 'aservices',
        },
        {
            name: 'OPERACIONES',
            title: true,
        },
        {
            name: 'Gestión de Rendiciones',
            icon: 'fas fa-tags',
            url: '/a3/ope/management-reports',
            permission: 'opemanagementreports',
        },
        {
            name: 'SERIES',
            title: true,
        },
        {
            name: 'Series Facile',
            icon: 'fas fa-folder',
            url: '/series/series-programs',
            permission: 'seriesfacile',
        },
        {
            name: 'MANTENIMIENTO',
            title: true,
        },
        {
            name: 'Inclusiones',
            icon: 'fas fa-clipboard-list',
            url: '/a3/maintenance/inclusions',
            permission: 'inclusions',
        },
        {
            name: 'Requerimientos',
            icon: 'fas fa-clipboard-list',
            url: '/a3/maintenance/requirements',
            permission: 'requirements',
        },
        {
            name: 'Actividades',
            icon: 'fas fa-clipboard-list',
            url: '/a3/maintenance/timings',
            permission: 'activities',
        },
        {
            name: 'Configuración de unidades',
            icon: 'fas fa-bus',
            url: '/a3/maintenance/transport-configuration',
            permission: 'transportconfigurator',
        },
        {
            name: 'Calendarios de países',
            icon: 'fas fa-calendar',
            url: '/a3/maintenance/country-calendar/general',
            permission: 'countrycalendar',
        },

    ],
}
